import styled from '@emotion/styled';

export const Panel = styled.div`
    max-width: 480px;
    margin: 0 auto;
    padding: ${({ theme }) => theme.spacing[5]};
    background: ${({ theme }) => theme.color.white100};
    border: 1px solid ${({ theme }) => theme.color.grey200};
    border-radius: ${({ theme }) => theme.radius.main};
    box-shadow: ${({ theme }) => theme.shadow.outside[200]};
    text-align: center;
`;

export const Title = styled.h1`
    margin: 0 0 ${({ theme }) => theme.spacing[3]} 0;
    font-family: ${({ theme }) => theme.font.family};
    font-size: ${({ theme }) => theme.font.size.large};
    color: ${({ theme }) => theme.color.black};
`;

export const Body = styled.p`
    margin: 0 0 ${({ theme }) => theme.spacing[4]} 0;
    color: ${({ theme }) => theme.color.grey500};
    font-family: ${({ theme }) => theme.font.family};
    font-size: ${({ theme }) => theme.font.size.normal};
    line-height: 1.5;
`;
